import { render, staticRenderFns } from "./PlannerStudentProgress.vue?vue&type=template&id=0bff11dc&scoped=true"
import script from "./PlannerStudentProgress.vue?vue&type=script&lang=js"
export * from "./PlannerStudentProgress.vue?vue&type=script&lang=js"
import style0 from "./PlannerStudentProgress.vue?vue&type=style&index=0&id=0bff11dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff11dc",
  null
  
)

export default component.exports